
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/report/marketing",
      function () {
        return require("private-next-pages/report/marketing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/report/marketing"])
      });
    }
  